<template>
    <div class="preloader-container">
        <div class="preloader">
            <div class="preloader-line" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Preloader'
}
</script>
